import React from 'react';
import classNames from 'classnames';

import { Arrow, Check, Close } from '@/icons/index';

import styles from './styles.module.scss';

const DropDownFilter = ({
  active,
  onSelect = () => null,
  data = [],
  title,
}) => {
  const renderTab = (item, index) => {
    let isActive;
    if (active.length) {
      isActive = active.find((activeItem) => activeItem?.id === item.id);
    }

    const arraysAreEqual =
      active.length === data.length &&
      active.every((v, i) => v.id === data[i].id);

    const onClick = () => {
      if (item.id === 0) {
        if (arraysAreEqual) return onSelect([]);
        return onSelect(data);
      }
      if (isActive) {
        const array = active.filter((activeItem) => {
          if (activeItem.id === 0) return false;
          return activeItem.id !== item.id;
        });

        return onSelect(array);
      }
      return onSelect([...active, item]);
    };

    return (
      <button
        key={index}
        className={classNames([styles.tab, { [styles.active]: isActive }])}
        onClick={onClick}
        aria-label={item.text}
      >
        <div className={styles.icon}>{isActive ? <Check /> : <Close />}</div>
        {item.text}
      </button>
    );
  };

  const inputTitle = React.useMemo(() => {
    const items = [];
    for (let i = 0; i <= active.length; i++) {
      if (active[i]?.id === 0) {
        items.push(active[i]?.text);
        break;
      }
      items.push(active[i]?.text);
    }
    return items;
  }, [active]);

  return (
    <div
      className={styles.container}
      itemScope
      itemType='https://schema.org/Action'
    >
      <div className={styles.title}>{title}</div>
      <div className={styles.input}>
        <input
          disabled
          value={inputTitle.filter((item) => !!item).join(', ')}
          aria-label={title}
        />
        <Arrow width={14} />
      </div>
      <div className={styles.panel}>{data.map(renderTab)}</div>
    </div>
  );
};

export default DropDownFilter;
